export type DesignScopeLodScope = "project" | "subscription";

export type DesignScopeLodRow = {
  id: string;
  level: string;
  name: string;
  description: string;
};

export type DesignScopeLodEnumValue = {
  id: number;
  value: string;
  description?: string | null;
  is_default: boolean;
  level_code?: string | null;
  sequence_no: number;
};

export type DesignScopeLodUpdateInput = {
  id: number;
  value: string;
  description: string;
  is_default: boolean;
};

export function mapLodEnumValuesToRows(
  enumValues: DesignScopeLodEnumValue[] | null | undefined
): { rows: DesignScopeLodRow[]; defaultId: string } {
  const sorted = [...(enumValues ?? [])].sort(
    (a, b) => a.sequence_no - b.sequence_no
  );
  const rows = sorted.map((item) => ({
    id: String(item.id),
    level: (item.level_code ?? "").trim() || String(item.id),
    name: item.value,
    description: item.description ?? ""
  }));
  const defaultItem = sorted.find((item) => item.is_default);
  return {
    rows,
    defaultId: defaultItem ? String(defaultItem.id) : ""
  };
}

export function toLodUpdateEnumValues(
  rows: DesignScopeLodRow[],
  defaultId: string
): DesignScopeLodUpdateInput[] {
  return rows.map((row) => ({
    id: Number(row.id),
    value: row.name,
    description: row.description,
    is_default: row.id === defaultId
  }));
}

export function cloneDesignScopeLodRows(
  rows: DesignScopeLodRow[]
): DesignScopeLodRow[] {
  return rows.map((row) => ({ ...row }));
}
